var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ad26b3eb49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.109375 10.128906 L 35.898438 10.128906 L 35.898438 29.371094 L 1.109375 29.371094 Z M 1.109375 10.128906 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad26b3eb49)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#143271",
    d: "M 3.078125 29.335938 C 3.605469 29.324219 4.054688 29.125 4.421875 28.746094 L 18.503906 14.664062 L 32.582031 28.746094 C 32.960938 29.132812 33.421875 29.328125 33.964844 29.328125 C 34.359375 29.328125 34.71875 29.21875 35.042969 29 C 35.371094 28.78125 35.605469 28.488281 35.753906 28.125 C 35.902344 27.761719 35.9375 27.386719 35.855469 27.003906 C 35.773438 26.617188 35.59375 26.289062 35.3125 26.015625 L 19.867188 10.570312 C 19.6875 10.386719 19.476562 10.25 19.242188 10.152344 C 19.003906 10.054688 18.757812 10.003906 18.503906 10.003906 C 18.246094 10.003906 18 10.054688 17.765625 10.152344 C 17.527344 10.25 17.320312 10.386719 17.136719 10.570312 L 1.691406 26.015625 C 1.40625 26.289062 1.222656 26.625 1.140625 27.011719 C 1.058594 27.402344 1.09375 27.78125 1.25 28.148438 C 1.402344 28.515625 1.644531 28.808594 1.980469 29.023438 C 2.3125 29.242188 2.679688 29.347656 3.078125 29.335938 Z M 3.078125 29.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.86fbba327fc130d9f4ab0dbe676932bd.svg";
export { ForwardRef as ReactComponent };